export default __webpack_public_path__ + "static/media/artCloseup@2x.30d93b6d.jpg";